import { Figure } from "@/data/registry";
import { ModeBadge } from "./ModeBadge";
import { SourceLine } from "./SourceLine";

export function FigureTile({ figure }: { figure: Figure }) {
  return (
    <article className="flex h-full flex-col gap-3 rounded-xl border border-border/60 bg-card/60 p-5 sm:p-6">
      <div className="flex items-start justify-between gap-3">
        <h3 className="text-[13px] font-semibold uppercase tracking-[0.08em] text-muted-foreground">
          {figure.label}
        </h3>
        <ModeBadge mode={figure.mode} />
      </div>

      <p className="font-display text-3xl font-bold leading-tight text-foreground sm:text-4xl">
        {figure.value}
      </p>

      {figure.detail && (
        <p className="text-sm leading-relaxed text-foreground/80">
          {figure.detail}
        </p>
      )}

      <div className="mt-auto space-y-2 pt-2">
        <SourceLine
          source={figure.source}
          sourceUrl={figure.sourceUrl}
          retrievedOn={figure.retrievedOn}
        />
        {figure.note && (
          <p className="text-[12px] italic leading-relaxed text-muted-foreground">
            {figure.note}
          </p>
        )}
      </div>
    </article>
  );
}
